// @flow
import React from 'react';
import DataTable from 'react-data-table-component';
import styled from 'styled-components';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import { formatUnixTimestamp } from 'utils/dateFormat';

const State = styled.span`
  text-transform: capitalize;
  font-weight: 700;
`;

function allMachines({ data }) {
  const columns = [
    {
      name: 'Company Name',
      selector: (row) => row.customer,
    },
    {
      name: 'Card Number',
      selector: (row) => row.cardNumber,
    },
    {
      name: 'Auction Reference Number',
      selector: (row) => row.auctionReferenceNumber,
    },
    {
      name: 'Pit Number',
      selector: (row) => row.lotNumber,
    },
    {
      name: 'Vehicle Number',
      selector: (row) => row.vehicleNumber,
    },
    {
      name: 'Status',
      selector: (row) => {
        const { status } = row;
        switch (status) {
          case 'weight-exceeded':
            return <State className="badge badge-warning">{status}</State>;
          case 'allowed-exit':
            return <State className="badge badge-danger">Exit</State>;
          case 'allowed-entry':
            return <State className="badge badge-success">Entry</State>;
          case 'no-card-data':
          case 'no-auction-data':
          default:
            return <State className="badge badge-info">No Logged-in Packet</State>;
        }
      },
      sortable: true,
    },
    {
      name: 'Swap At',
      selector: (row) => {
        return formatUnixTimestamp(row.swapTime);
      },
      sortable: true,
    },
  ];
  return (
    <Card>
      <CardContent>
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          Latest logs/events
          <Chip label="Real time logs/events" style={{ float: 'right' }} />
        </Typography>
        <div className="table-responsive">
          <DataTable columns={columns} data={data} pagination persistTableHead />
        </div>
      </CardContent>
    </Card>
  );
}

export default allMachines;
